import { Text } from "@chakra-ui/react"

const GuestPriceNotice = () => {
    return (
        <Text color="gray.400" fontSize="sm" mt={2}>Đăng nhập để xem giá</Text>
    )
}

export default GuestPriceNotice